export const radioButtonTheme = {
  colorScheme: {
    light: {
      checked: {
        hover: {
          background: '{sd.secondary.hovercolor.darker}',
          border: {
            color: '{override.primary.color}'
          }
        },
        background: '{sd.backgrounds.secondary.color}'
      },
      disabled: {
        background: '{sd.backgrounds.readonly}',
        color: '{sd.form.action.background.color}'
      },
      icon: {
        disabledColor: '{sd.form.action.background.color}'
      }
    }
  }
};
